import React from 'react';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={styles.footer}>
      <p style={styles.name}>Ace Apartments</p>
      <p style={styles.meta}>Eldoret, Kenya · info@aceapartments.co.ke · 0712 345 678</p>
      <p style={styles.copy}>© {year} Ace Apartments. All rights reserved.</p>
    </footer>
  );
}

const styles = {
  footer: {
    textAlign: 'center',
    padding: '32px 24px',
    borderTop: '1px solid var(--color-border)',
  },
  name: {
    fontFamily: 'var(--font-display)',
    fontSize: '14px',
    fontWeight: 700,
    color: 'var(--color-ink)',
    margin: '0 0 6px',
  },
  meta: {
    fontSize: '13px',
    color: 'var(--color-muted)',
    margin: '0 0 6px',
  },
  copy: {
    fontSize: '12px',
    color: 'var(--color-muted)',
    margin: 0,
  },
};

export default Footer;
